<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal,
  BButton,
  BAlert,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  AlertPlugin,
  BForm,
  BFormInput,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@core/utils/validations/validations';

export default {
  components: {
    BFormInput,
    BForm,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        canal_venda_id: '',
        canal_venda_descricao: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="md"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.canal_venda_descricao === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              md="12"
          >
            <b-form-group
                label="Codigo"
                label-for="canal_venda_id"
            >
              <b-form-input
                  id="canal_venda_id"
                  v-model="dataForm.canal_venda_id"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="12"
          >
            <b-form-group
                label="Descricao"
                label-for="canal_venda_descricao"
            >
              <b-form-input
                  id="canal_venda_descricao"
                  v-model="dataForm.canal_venda_descricao"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>

        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
